export default __webpack_public_path__ + "locales/fi/UploadPanel.json?hash=3e3ca2eb9a29bbc23157c972139c4645";